import React from 'react';
import styled from 'styled-components';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: 50%;
  cursor: pointer;
  transition: all ${props => props.theme.transitions.fast};
  color: ${props => props.theme.colors.text.primary};

  &:hover {
    background-color: ${props => props.theme.colors.primaryLight};
    border-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
  }

  &:focus-visible {
    outline: 2px solid ${props => props.theme.colors.primary};
    outline-offset: 2px;
  }

  svg {
    transition: transform ${props => props.theme.transitions.fast};
  }

  &:hover svg {
    transform: rotate(15deg) scale(1.1);
  }
`;

const ToggleContainer = styled.div`
  position: relative;
  display: none;
  align-items: center;
`;

export const ThemeToggle = ({ className }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <ToggleContainer className={className}>
      <ToggleButton
        onClick={toggleTheme}
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      >
        {isDarkMode ? (
          <Sun size={18} />
        ) : (
          <Moon size={18} />
        )}
      </ToggleButton>
    </ToggleContainer>
  );
};